import {stringify} from 'qs';
import {getIsPageHostname} from '../../common/getIsPageHostname';
import {AgreementVo} from '../../common/shared/api/nicolas/vo/AgreementVo.interface';
import {Agreement} from '../generated/types';
import {createAgreementType} from './AgreementType';

export function createAgreement(
  agreementVo: AgreementVo,
  isWebView: boolean,
  isGlobal?: boolean
): Agreement {
  return {
    title: agreementVo.title,
    uid: agreementVo.uid,
    type: createAgreementType(agreementVo.agreement_type),
    url: appendPolicyQueryStringToUrl(
      isWebView,
      getPathname(agreementVo.url),
      isGlobal
    ),
    isRequired: agreementVo.required,
    version: agreementVo.version,
  };
}

/**
 * API에서 origin이 포함된 url을 내려주고 있어서 pageweb origin일 경우 path만 주도록 변경합니다.
 * 참고로 베타환경에서 real DB를 쓰는거 같아 리얼 주소를 보내주고 있어서 베타 환경에서 약관 테스트하기 어려워서 처리한 작업입니다.
 */
function getPathname(url?: string) {
  if (!url) {
    return undefined;
  }
  return getIsPageHostname(url) ? new URL(url).pathname : url;
}

/**
 * policy 페이지 URL에 환경에 맞게 쿼리스트링을 붙여주는 함수입니다.
 */
function appendPolicyQueryStringToUrl(
  isWebView: boolean,
  url?: string,
  isGlobal?: boolean
) {
  if (!url) {
    return;
  }
  return `${url}${url?.includes('?') ? '&' : '?'}${stringify(
    isWebView
      ? isGlobal
        ? {showWebHeader: true}
        : {needCloseButton: true}
      : {
          showNewWindow: true,
          hideMenu: true,
        }
  )}`;
}
